import React from 'react';
import { StatusBadge as StatusBadgeContainer, StatusText } from './styles';
export var StatusBadge = function (_a) {
    var status = _a.status;
    return (React.createElement(StatusBadgeContainer, { "$status": status },
        React.createElement(StatusText, { "$status": status }, status)));
};
